import { KalaTheme } from '../models/user-setting.model';

/**
 * The colour the browser paints its own chrome in — an installed PWA's status and
 * navigation bars. Each is the theme's page background (`--color-gray-000`), so the bars
 * read as part of the app. The same pair is in `index.html` for the first paint.
 */
export const THEME_BROWSER_COLOR: Record<KalaTheme, string> = {
	classic: '#FFFFFF',
	dark: '#232933'
};
